import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Calendar, Clock, MapPin, Users, Loader2, Save } from 'lucide-react';
import { toast } from 'react-hot-toast';
import config from '../config';

export const InstallerSchedulePage = () => {
  const { contractId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [contract, setContract] = useState(null);
  const [schedule, setSchedule] = useState({
    start_date: '',
    estimated_days: 3,
    team_members: 2,
    notes: '',
  });

  useEffect(() => {
    fetchContract();
  }, [contractId]);

  const fetchContract = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch(config.getApiUrl(`/marketplace/contracts/${contractId}/`), {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setContract(data);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch(config.getApiUrl(`/marketplace/contracts/${contractId}/schedule/`), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(schedule)
      });
      
      if (response.ok) {
        toast.success('زمان‌بندی با موفقیت ثبت شد');
        navigate('/installer/contracts');
      } else {
        toast.error('خطا در ثبت زمان‌بندی');
      }
    } catch (error) {
      toast.error('خطا در ارتباط با سرور');
    } finally {
      setLoading(false);
    }
  };

  if (!contract) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="bg-blue-600 p-6 text-white">
            <h1 className="text-2xl font-bold">زمان‌بندی نصب</h1>
            <p className="text-blue-100 mt-2">قرارداد #{contract.id}</p>
          </div>
          
          <div className="p-6">
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <h3 className="font-bold mb-2">اطلاعات پروژه</h3>
              <div className="space-y-2 text-sm">
                <p><span className="text-gray-500">آدرس:</span> {contract.installation_request?.address}</p>
                <p><span className="text-gray-500">مبلغ قرارداد:</span> {contract.bid?.proposed_cost?.toLocaleString()} تومان</p>
              </div>
            </div>
            
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-1">تاریخ شروع نصب *</label>
                <div className="relative">
                  <Calendar className="absolute right-3 top-3 w-5 h-5 text-gray-400" />
                  <input
                    type="date"
                    value={schedule.start_date}
                    onChange={(e) => setSchedule({...schedule, start_date: e.target.value})}
                    className="w-full border rounded-lg pr-10 py-2"
                    required
                    min={new Date().toISOString().split('T')[0]}
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1">مدت زمان تخمینی (روز)</label>
                  <div className="relative">
                    <Clock className="absolute right-3 top-3 w-5 h-5 text-gray-400" />
                    <input
                      type="number"
                      value={schedule.estimated_days}
                      onChange={(e) => setSchedule({...schedule, estimated_days: parseInt(e.target.value)})}
                      className="w-full border rounded-lg pr-10 py-2"
                      min="1"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium mb-1">تعداد تکنسین‌ها</label>
                  <div className="relative">
                    <Users className="absolute right-3 top-3 w-5 h-5 text-gray-400" />
                    <input
                      type="number"
                      value={schedule.team_members}
                      onChange={(e) => setSchedule({...schedule, team_members: parseInt(e.target.value)})}
                      className="w-full border rounded-lg pr-10 py-2"
                      min="1"
                    />
                  </div>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1">توضیحات تکمیلی</label>
                <textarea
                  value={schedule.notes}
                  onChange={(e) => setSchedule({...schedule, notes: e.target.value})}
                  rows={4}
                  className="w-full border rounded-lg px-3 py-2"
                  placeholder="اطلاعات اضافی برای مشتری..."
                />
              </div>
              
              <div className="flex justify-end gap-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => navigate('/installer/contracts')}
                  className="px-6 py-2 border rounded-lg"
                >
                  انصراف
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg flex items-center gap-2"
                >
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
                  ثبت زمان‌بندی
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
